import {
    ADD_JURISDICTION_TO_TEAM,
    ADD_JURISDICTION_TO_TEAM_FAIL,
    ADD_JURISDICTION_TO_TEAM_SUCCESS,
    DELETE_JURISDICTION_FROM_TEAM,
    DELETE_JURISDICTION_FROM_TEAM_FAIL,
    DELETE_JURISDICTION_FROM_TEAM_SUCCESS
} from './actionTypes';

const initialState = {
    teamId: null,
    add: {
        newJurisdiction: null,
        addedJurisdiction: null,
        error: null,
        loading: false,
        loaded: false
    },
    delete: {
        jurisdictionToBeDeleted: null,
        deletedJurisdiction: null,
        error: null,
        loading: false,
        loaded: false
    }
};

export function teamJurisdictionReducer(state = initialState, action) {
    switch (action.type) {
        case ADD_JURISDICTION_TO_TEAM:
            return {
                ...state,
                teamId: action.payload.teamId,
                add: {
                    ...initialState.add,
                    newJurisdiction: action.payload.jurisdictions,
                    loading: true
                }
            };
        case ADD_JURISDICTION_TO_TEAM_SUCCESS:
            return {
                ...state,
                add: {
                    ...state.add,
                    addedJurisdiction: action.payload,
                    loaded: true,
                    loading: false
                }
            };
        case ADD_JURISDICTION_TO_TEAM_FAIL: {
            return {
                ...state,
                add: {
                    ...state.add,
                    error: action.payload,
                    loading: false
                }
            };
        }

        case DELETE_JURISDICTION_FROM_TEAM:
            return {
                ...state,
                teamId: action.payload.teamId,
                delete: {
                    ...initialState.delete,
                    jurisdictionToBeDeleted: action.payload.jurisdiction,
                    loading: true
                }
            };
        case DELETE_JURISDICTION_FROM_TEAM_SUCCESS:
            return {
                ...state,
                delete: {
                    ...state.delete,
                    deletedJurisdiction: action.payload,
                    loaded: true,
                    loading: false
                }
            };
        case DELETE_JURISDICTION_FROM_TEAM_FAIL: {
            return {
                ...state,
                delete: {
                    ...state.delete,
                    error: action.payload,
                    loading: false
                }
            };
        }
        default:
            return state;
    }
}
